// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"563":"dc2f8c83","579":"5dd968f5"}[chunkId] + ".chunk.css";
};